import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {withTranslation, WithTranslation} from "react-i18next";
import {UserState} from "../../store/user/types";
import {ReachElement, ReachPart, ReachState} from "../../store/reach/types";
import {setEditingReachElements} from "../../store/reach/actions";
import {compose} from "redux";
import {connect} from "react-redux";
import {AppState} from "../../store";
import axios from "axios";
import Paper from '@material-ui/core/Paper';
import {Button, createStyles, TextField, Theme, Toolbar, WithStyles, withStyles} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";


type PartsProps = RouteComponentProps & WithTranslation & WithStyles & {
    userState: UserState;
    reachState: ReachState;
    setEditingReachElements: typeof setEditingReachElements;
}

interface IPartsState {
    predefinedParts: Array<ReachPart>;
    addingPart: ReachPart | undefined;
    customPart: ReachPart | undefined;
    editingElement: ReachElement | undefined;
}

class ReachParts extends React.Component<PartsProps, IPartsState> {

    render() {
        const t = this.props.t;
        const classes = this.props.classes;
        const editingReachElement = this.state.editingElement;
        return (
            <Paper style={{padding: "10px", margin: "25px"}}>
                <Toolbar>
                    <Typography color="inherit" variant="h6">{t('ReachParts.title')}</Typography>
                </Toolbar>
                <p>{t('ReachParts.predefinedParts')}</p>
                <div className={classes.addPredefinedPartRow}>
                    <FormControl className={classes.addPredefinedPartControl}>
                        <InputLabel htmlFor="addingPredefinedPart">{t('ReachParts.part')}</InputLabel>
                        <Select value={this.state.addingPart ? this.state.addingPart.id : ''}
                                onChange={this.onSelectPredefinedPart}
                                inputProps={{
                                    name: 'addingPredefinedPart',
                                    id: 'addingPredefinedPart',
                                }}>
                            {this.state.predefinedParts && this.state.predefinedParts.map((p: ReachPart) => (
                                <MenuItem id={p.id!.toString()}
                                          value={p.id}>{this.props.i18n.language == 'de' ? p.descriptionD : p.descriptionE}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button variant="contained" color="primary" onClick={this.addPredefinedPart}
                            className={this.props.classes.button}>{t('ReachParts.addPart')}</Button>
                </div>
                <div className={classes.addPredefinedPartRow}>
                    <FormControl margin="normal" className={classes.addPredefinedPartControl}>
                        <List component="nav">
                            {editingReachElement && editingReachElement.parts && editingReachElement.parts.map((p: ReachPart, i: number) => ([
                                <ListItem key={i}>
                                    <ListItemIcon><span>{i + 1}</span></ListItemIcon>
                                    <ListItemText
                                        primary={this.props.i18n.language == 'de' ? p.descriptionD : p.descriptionE}/>
                                    <ListItemSecondaryAction>
                                        <IconButton aria-label={t('common.delete')}
                                                    onClick={() => this.removePredefinedPart(i)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>,
                                <Divider/>
                            ]))}
                        </List>
                    </FormControl>
                </div>
                <Divider/>
                <p>{t('ReachParts.customPart')}</p>
                <form className={classes.container} noValidate autoComplete="off">
                    <TextField
                        id="description"
                        label={t('ReachParts.customPartDescription')}
                        className={classes.customPartDescription}
                        value={this.state.customPart ? this.state.customPart.descriptionE : ''}
                        onChange={this.onCustomPartDescriptionChange}
                        margin="normal"
                    />
                </form>
                <Divider/>
                <Toolbar>
                    <div className={this.props.classes.toolbarButtonContainer}>
                        <Button variant="contained" color="primary" onClick={this.saveParts}
                                className={this.props.classes.button}>{t('common.save')}</Button>
                        <Button variant="contained" onClick={this.cancel}
                                className={this.props.classes.button}>{t('common.cancel')}</Button>
                    </div>
                </Toolbar>
            </Paper>
        );
    }

    onCustomPartDescriptionChange = (event: React.ChangeEvent) => {
        let description = (event.target as HTMLInputElement).value;
        let part = undefined;
        if (description) {
            part = this.state.customPart || {custom: true, active: true};
            part.descriptionE = description;
            part.descriptionD = description;
        }
        this.setState({customPart: part});
    }

    onSelectPredefinedPart = (event: React.ChangeEvent) => {
        let preDefindPartId = Number((event.target as HTMLInputElement).value);
        let predefinedPart = this.state.predefinedParts.find((p: ReachPart) => p.id === preDefindPartId);
        this.setState({addingPart: (predefinedPart || {id: -1, custom: false, active: true})});
    }

    addPredefinedPart = () => {
        console.log('Adding the pre defined part with id. ' + this.state.addingPart!.id);
        let element = this.getEditingElement();
        if (!element.parts) {
            element.parts = [];
        }
        let part = this.state.addingPart!;
        if (!element.parts.includes(part)) {
            element.parts.push(part);
            this.setState({editingElement: element});
        }
    }

    removePredefinedPart = (index: number) => {
        console.log('Removing the pre defined part with index. ' + index);
        let element = this.getEditingElement();
        element.parts!.splice(index, 1);
        this.setState({editingElement: element});
    }

    cancel = () => {
        this.props.history.goBack();
    }

    componentWillMount() {
        let substanceId = this.props.location.state.substanceId;
        console.log('Editing parts for substance ' + substanceId);
        let editingElement = this.props.reachState.editingReachElements.find((e: ReachElement) => e.substanceId == substanceId);
        editingElement = editingElement ? JSON.parse(JSON.stringify(editingElement)) : {substanceId: substanceId}; // clone it
        let customPart;
        if (editingElement && editingElement.parts) {
            let customPartIndex = editingElement.parts.findIndex((p: ReachPart) => p.custom);
            if (customPartIndex > -1) {
                customPart = editingElement.parts[customPartIndex];
                editingElement.parts.splice(customPartIndex, 1);
            }
        }
        this.setState({editingElement: editingElement, customPart: customPart});
        this.loadPredefinedParts();
    }

    getEditingElement(): ReachElement {
        return this.state.editingElement || {substanceId: this.props.location.state.substanceId};
    }

    loadPredefinedParts() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/parts/allNotCustom';
        axios.get(url)
            .then(res => {
                if (res.status == 200) {
                    if (res.data) {
                        console.log('Loaded ' + res.data.length + ' predefined parts');
                        this.setState({predefinedParts: res.data});
                    } else {
                        console.log('Failed to get predefined parts: no data!');
                    }
                } else {
                    console.log('Failed to get predefined parts: server error ' + res.status + '!');
                }
            })
            .catch(err => {
                console.log('Failed to get predefined parts: server error');
                console.log(err);
            });
    }

    saveParts = () => {
        let element = this.state.editingElement!;
        if (!element.parts) {
            element.parts = [];
        }
        if (this.state.customPart) {
            element.parts.push(this.state.customPart);
        } else {
            let partIndex = element.parts.findIndex(p => p.custom);
            if (partIndex != -1) {
                element.parts.splice(partIndex, 1);
            }
        }
        if (element.parts && element.parts.length > 0) {
            if (element.validation) {
                let errorIndex = element.validation.findIndex(v => v == 'ReachElements.validation.missingPartsError');
                if (errorIndex != -1) {
                    element.validation.splice(errorIndex, 1);
                }
            }
        } else {
            if (element.validation) {
                let errorIndex = element.validation.findIndex(v => v == 'ReachElements.validation.missingPartsError');
                if (errorIndex == -1) {
                    element.validation.push('ReachElements.validation.missingPartsError');
                }
            } else {
                element.validation = ['ReachElements.validation.missingPartsError'];
            }
        }
        let elements = this.props.reachState.editingReachElements;
        let index = elements.findIndex((e: ReachElement) => e.substanceId == element.substanceId);
        if (index == -1) {
            elements.push(element);
        } else {
            elements[index] = element;
        }
        this.props.setEditingReachElements(elements);
        this.props.history.goBack();
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    toolbarButtonContainer: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    button: {
        marginLeft: spacing.unit
    },
    addPredefinedPartRow: {
        display: 'flex',
        flexGrow: 1
    },
    addPredefinedPartControl: {
        width: 600
    },
    customPartDescription: {
        width: 600
    }
});

const mapStateToProps = (state: AppState) => ({
    userState: state.user,
    reachState: state.reach
});

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation('common'),
    connect(mapStateToProps, {setEditingReachElements})
)(ReachParts) as any;